var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExp1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.571,
    height: 47,
    viewBox: "0 0 52.571 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "briefcase-solid",
    d: "M32.857,63.214a1.642,1.642,0,0,1-1.643,1.643H21.357a1.642,1.642,0,0,1-1.643-1.643V58.286H0V73.071A5.053,5.053,0,0,0,4.929,78H47.643a5.053,5.053,0,0,0,4.929-4.929V58.286H32.857ZM47.643,41.857H39.429V36.929A5.053,5.053,0,0,0,34.5,32H18.071a5.053,5.053,0,0,0-4.929,4.929v4.929H4.929A5.053,5.053,0,0,0,0,46.786V55H52.571V46.786A5.053,5.053,0,0,0,47.643,41.857Zm-14.786,0H19.714V38.571H32.857Z",
    transform: "translate(0 -32)",
    fill: "#bc5e0a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExp1);
export default __webpack_public_path__ + "static/media/exp-1.f75d34ddda793f649eee6148f8a12a9f.svg";
export { ForwardRef as ReactComponent };